import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';
import { PermissionWrapper } from 'src/pages/auth/hooks/permissionWrapper';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------

const CsatDashboardPage = lazyWithReload(() => import('src/pages/csat/csat-dashboard-page'));
const CsatConfigurationPage = lazyWithReload(
  () => import('src/pages/csat/csat-configuration-page')
);

const ComingSoonPage = lazyWithReload(() => import('src/pages/error/coming-soon'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const csatRoutes: RouteObject[] = [
  {
    path: 'csat',
    element: CONFIG.auth.skip ? dashboardLayout() : <AuthGuard>{dashboardLayout()}</AuthGuard>,
    children: [
      {
        index: true,
        element: (
          <PermissionWrapper module="csat_analytics">
            <CsatDashboardPage />
          </PermissionWrapper>
        ),
      },
      {
        path: 'config',
        element: (
          <PermissionWrapper module="csat_config">
            <CsatConfigurationPage />
          </PermissionWrapper>
        ),
      },
    ],
  },
];
